export default "__VITE_ASSET__484206b5__"